import clsx from 'clsx'
import styles from './Password.module.css'
import {
  isMobile
} from 'react-device-detect'
import {
  get_maximum
} from '../../Functions/Functions'

const Password = ({ password }) => {
  const length = password.length
  const maximum = (get_maximum() / 2)
  const middle = Math.floor(length / 2)
  return (
    <div className={styles.div}>
      <span
        className={
          clsx({
            [styles.span]: true,
            [styles.mobile]: isMobile
          })
        }
      >
        {
          (length > maximum)
            ? <>
                {password.slice(0, middle)}
                <br/>
                {password.slice(middle)}
              </>
            : password
        }
      </span>
    </div>
  )
}

export default Password
